'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mergeWithDefaults = mergeWithDefaults;
var DEFAULT_IDP_CONFIG = {
  ajaxSupport: {
    login: false,
    loginMethod: 'GET',
    refresh: false,
    logout: true,
    logoutMethod: 'GET'
  },
  expiryInMilliseconds: false,
  loginParameter: {
    scope: 'openid profile',
    state: 'myState',
    response_type: 'token id_token'
  },
  logoutParameter: {}
};

function mergeWithDefaults(config) {
  return _extends({}, DEFAULT_IDP_CONFIG, config, {
    ajaxSupport: _extends({}, DEFAULT_IDP_CONFIG.ajaxSupport, config.ajaxSupport),
    loginParameter: _extends({}, DEFAULT_IDP_CONFIG.loginParameter, config.loginParameter),
    logoutParameter: _extends({}, DEFAULT_IDP_CONFIG.logoutParameter, config.logoutParameter)
  });
}